import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("link", component(opts));
  editor.BlockManager.add("link", block(opts));
};